import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { ARRMGR_COUNTRY_PARAM } from "@rhinov/asset-manager-service"

export class ShowPriorityFilter implements IFilter {
    id: string;
    type: string;
    controller: FiltersController;
    parentGroup: FilterGroup;
    checkCountry: boolean;

    constructor(parentGroup: FilterGroup, checkCountry: boolean) {
        this.id = 'showPriority';
        this.type = 'showPriority';
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
        this.checkCountry = checkCountry;
    }

    html(): string {
        let html = `
        <form id="showPriorityForm">
            <div>
                <input id="showMDM" class="btn-default" type="radio" name="priority" value="MDM"> MDM
            </div>
            <div` + (FilterGroup.countryHasMarketplace ? `` : ` style="display: none;"`) + `>
                <input id="showMarketPlace" class="btn-default" type="radio" name="priority" value="MKP_MDM"> MarketPlace MDM
            </div>
            <div>
                <input id="showReferenced" class="btn-default" type="radio" name="priority" value="REFERENCED"> Référencés
            </div>
            <div>
                <input id="showGeneric" class="btn-default" type="radio" name="priority" value="GENERIC"> Génériques
            </div>
            <div>
                <input id="showPlaceHolders" class="btn-default" type="radio" name="priority" value="PLACEHOLDERS"> Placeholders
            </div>
        </form>
        `;
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            let form = $('#showPriorityForm');
            form.find('input[type="radio"]').each((_index, element) => {
                this.controller.addEventListener('change', () => {
                    let val = $(element).val() as string;
                    FilterGroup.filters.showPriority = val;
                    FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
                }, element.id);
            });

            if (FilterGroup.filters.showPriority) {
                form.find(`input[type="radio"][value="${FilterGroup.filters.showPriority}"]`).prop('checked', true);
            }
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        let stringFilters = '';

        if (!FilterGroup.smartSearch()) {
            switch (FilterGroup.filters.showPriority) {
                case 'MDM':
                    stringFilters += '&q.manufacturer.in=579b5fc0d7ee59f805e3c065';
                    if (FilterGroup.filters.showUnavailable !== true && FilterGroup.filters.showContentFactory !== true) {
                        stringFilters += ARRMGR_COUNTRY_PARAM;
                    }
                    break;
                case 'MKP_MDM':
                    stringFilters += '&q.retailer.in=579b5fc0d7ee59f805e3c065';
                    if (FilterGroup.filters.showUnavailable !== true && FilterGroup.filters.showContentFactory !== true) {
                        stringFilters += ARRMGR_COUNTRY_PARAM;
                    }
                    break;
                case 'REFERENCED':
                    stringFilters += '&q.manufacturer.nin=5dc1444db70bd31e474747de,5be2c40c2e50ee46876e546d';
                    // if (FilterGroup.filters.showUnavailable !== true && FiltersWidget.currentFiltersGroup.id !== 'coatings') {
                    //     stringFilters += ARRMGR_COUNTRY_PARAM;
                    // }
                    break;
                case 'CLIENT':
                    stringFilters += '&q.manufacturer.in=5dc1444db70bd31e474747de';
                    break;
                case 'GENERIC':
                    stringFilters += '&q.manufacturer.in=5be2c40c2e50ee46876e546d&descending=objectType&q.objectType.nin=5bc064b9efe98c5c27d0a801,5c34c0873614a6380e44ddeb,5bc06cbebe6c755c1fb2d5e3,5bc06c1fd08ceb5c26f750c9,5f915356d651782a0ec38941,5bc06b51b130575c39f762ab,5cc035899de2486cda32775c';
                    break;
                case 'PLACEHOLDERS':
                    stringFilters += '&q.manufacturer.in=5df89bb3c5b06666d1a38703';
                    break;
            }
        }

        return(stringFilters);
    }

    destroy(): void {
        this.controller.destroy();
    }

}